import {
  IOrderTemplate,
  OrderTemplate,
  OrderTemplateLine,
  IItem,
  ISupplier,
  IBrand,
  IUnit,
} from '$models'
import { PurchaseOrderUi } from '../../purchase-orders/types'

export function convertOrderTemplateToPurchaseOrderUi(
  orderTemplate: IOrderTemplate | null
) {
  const purchaseOrderUi: PurchaseOrderUi = {
    id: orderTemplate?.id,
    templateName: orderTemplate?.name,
    createdAt: orderTemplate?.createdAt,
    creditRequest: orderTemplate?.creditRequest,
    lines:
      orderTemplate?.lines?.map((line) => ({
        ...line,
        lineId: line.id ?? crypto.randomUUID(),
        itemCode: line.stockCode,
        itemId: line.stockItemId,
        itemName: line.stockItemName,
        brandId: line.brandId,
        supplierId: line.supplierId,
        unitId: line.unitId,
        quantityOrdered: line.quantity,
        unitCostOrdered: line.unitCost,
        unitRatio: line.unitRatio,
        __reorder__: line.stockCode ?? '',
        isEstimatedCostLoading: false,
      })) ?? [],
  }
  return purchaseOrderUi
}

export function convertPurchaseOrderUiToOrderTemplate(
  purchaseOrderUi: PurchaseOrderUi,
  items?: Record<string, IItem>,
  suppliers?: Record<string, ISupplier>,
  brands?: Record<string, IBrand>,
  units?: Record<string, IUnit>
): OrderTemplate {
  const lines = purchaseOrderUi?.lines?.map((uiLine, index) => {
    return new OrderTemplateLine({
      id: uiLine.id,
      templateId: purchaseOrderUi.id,
      stockItemId: uiLine.itemId,
      stockItemName:
        (uiLine.itemId && items?.[uiLine.itemId]?.name) || uiLine.itemName,
      supplierId: uiLine.supplierId,
      supplierName:
        (uiLine.supplierId && suppliers?.[uiLine.supplierId]?.name) || '',
      brandId: uiLine.brandId,
      brandName:
        (uiLine.brandId && brands?.[uiLine.brandId]?.name) || uiLine.brandName,
      unitId: uiLine.unitId,
      unitName:
        (uiLine.unitId && units?.[uiLine.unitId]?.name) || uiLine.unitName,
      unitRatio: uiLine.unitRatio,
      stockCode: uiLine.itemCode || '',
      unitCost: (uiLine?.unitCostOrdered || 0) * (uiLine?.unitRatio || 1),
      quantity: uiLine?.quantityOrdered || 0,
      lineOrder: index,
    })
  })

  const orderTemplate = new OrderTemplate({
    id: purchaseOrderUi.id,
    name: purchaseOrderUi.templateName,
    createdAt: purchaseOrderUi.createdAt,
    creditRequest: purchaseOrderUi.creditRequest,
    lines: lines,
  })

  return orderTemplate
}
